//medidad Banner 650x360px
export const ultimasNoticias = [
   {
        "imagen" :"../assets/imgs/Convocatorias/2026/Resultados de la convocatoria Celeblando la Danza en los CCRs.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/Resultados Danza en los CCRs.jpeg",
        "titulo" : "Resultados de la convocatoria Celeblando la Danza en los Centros Culturales Regionales",
        "fecha" : ""
    },
   {
        "imagen" :"../assets/imgs/Convocatorias/2026/encuentro estatal.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/Resultados Encuentro estatal.jpeg",
        "titulo" : "Resultados de la convocatoria Encuentro Estatal de la Danza Contemporanea",
        "fecha" : ""
    },
  {
        "imagen" :"../assets/imgs/Convocatorias/2026/Resultados Celebrando la Danza en Hidalgo.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/Resultados danza .jpeg",
        "titulo" : "Resultados de la convocatoria Celebrando la Danza en Hidalgo",
        "fecha" : ""
    },
   {
        "imagen" :"../assets/imgs/Convocatorias/2026/Resultados AyR 2026.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/6.-Resultados AyR 2026, Hidalgo..pdf",
        "titulo" : "Resultados de la convocatoria Alas y Raíces 2026",
        "fecha" : ""
    },
   ]